"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// eslint-disable-next-line import/prefer-default-export
var AnalyticsContentType;
(function (AnalyticsContentType) {
    AnalyticsContentType["SHOW"] = "Show";
    AnalyticsContentType["MOVIE"] = "Movie";
    AnalyticsContentType["SPORT"] = "Sport";
})(AnalyticsContentType = exports.AnalyticsContentType || (exports.AnalyticsContentType = {}));
//# sourceMappingURL=AnalyticsContentType.js.map